/**
 * A loading task
 */
export interface LoadingTask {
  id: string;
  meta:
    | {
        type: "spinner";
        text: string;
      }
    | {
        type: "progress";
        value: number;
        max: number;
        text: string;
      };
}

/**
 * Default loading task ids
 */
export enum GameLoadingTaskId {
  LoadingGameWorld = "loadingGameWord",
}
